import { motion } from "framer-motion";
import Layout from "@/components/Layout";
import SEOHead from "@/components/SEOHead";

const TermsOfService = () => {
  return (
    <Layout>
      <SEOHead
        title="Terms of Service — Dhivisha Architects"
        description="Terms of Service for Dhivisha Architects. Read our terms and conditions for using our architectural design services."
        path="/terms-of-service"
      />
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-2">Terms of Service</h1>
            <p className="text-sm text-muted-foreground mb-10">Last updated: March 27, 2026</p>

            <div className="prose prose-sm max-w-none space-y-8 text-muted-foreground">
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">1. Services</h2>
                <p>
                  Dhivisha Architects provides architectural design, interior design, construction consulting, and related services. The specific scope of work for each project will be defined in a separate agreement or proposal.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">2. Client Responsibilities</h2>
                <p>Clients agree to:</p>
                <ul className="list-disc pl-6 space-y-1 mt-2">
                  <li>Provide accurate and complete project information</li>
                  <li>Make timely decisions and approvals as required</li>
                  <li>Make payments as per the agreed schedule</li>
                  <li>Obtain necessary permits and approvals from local authorities</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">3. Intellectual Property</h2>
                <p>
                  All designs, drawings, plans, and documents created by Dhivisha Architects remain our intellectual property until full payment is received. Upon full payment, the client receives a license to use the designs for the specified project only. Designs may not be reused, reproduced, or shared without written consent.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">4. Fees and Payment</h2>
                <p>
                  Project fees will be outlined in the proposal or agreement. Payment terms, including advance payments and milestone-based installments, will be specified for each project. Late payments may result in project delays or suspension of services.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">5. Project Timeline</h2>
                <p>
                  Project timelines are estimates and may be affected by factors including client approvals, regulatory processes, material availability, and weather conditions. We will communicate any significant changes to the timeline promptly.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">6. Revisions and Changes</h2>
                <p>
                  A reasonable number of design revisions are included in our fees as specified in the project agreement. Additional revisions or scope changes beyond the agreed terms may incur extra charges, which will be communicated before proceeding.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">7. Limitation of Liability</h2>
                <p>
                  Dhivisha Architects shall not be liable for delays, losses, or damages arising from circumstances beyond our reasonable control, including natural disasters, regulatory changes, or contractor-related issues. Our total liability shall not exceed the fees paid for the specific project.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">8. Termination</h2>
                <p>
                  Either party may terminate the agreement with written notice. In case of termination, the client shall pay for all work completed up to the date of termination. Any advance payments for uncompleted work will be refunded as per the terms of the project agreement.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">9. Governing Law</h2>
                <p>
                  These terms shall be governed by and construed in accordance with the laws of India. Any disputes arising from these terms shall be subject to the jurisdiction of courts in Kumbakonam, Tamil Nadu.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">10. Contact Us</h2>
                <p>For any questions regarding these Terms of Service, please contact us at:</p>
                <div className="mt-2">
                  <p><strong className="text-foreground">Dhivisha Architects</strong></p>
                  <p>No:9, Needamangalam Rd, Elanga Nagar, Srinivas Nagar, Sakkottai, Kumbakonam, Tamil Nadu 612001</p>
                  <p>Email: mail@dhivishaarchitects.com</p>
                  <p>Phone: +91 99948 49332 / +91 84280 77535</p>
                </div>
              </section>
            </div>
          </motion.div>
        </div>
      </section>
    </Layout>
  );
};

export default TermsOfService;
